export const URL_LOGO_VERTICAL =
  'https://www.viraje360.com/medicarmen/wp-content/themes/medicarmen/img/logotipo-medicarmen-clinica.svg';
export const URL_LOGO_HORIZONTAL =
  'https://www.viraje360.com/medicarmen/wp-content/themes/medicarmen/img/logotipo-medicarmen.svg';
